/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Property time zone
 * @export
 * @interface TravelineTimeZoneInfoDto
 */
export interface TravelineTimeZoneInfoDto {
    /**
     * Time zone ID.<br />
     * corresponds to IANA Time Zones ID
     * @type {string}
     * @memberof TravelineTimeZoneInfoDto
     */
    id: string;
}

/**
 * Check if a given object implements the TravelineTimeZoneInfoDto interface.
 */
export function instanceOfTravelineTimeZoneInfoDto(value: object): value is TravelineTimeZoneInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineTimeZoneInfoDtoFromJSON(json: any): TravelineTimeZoneInfoDto {
    return TravelineTimeZoneInfoDtoFromJSONTyped(json, false);
}

export function TravelineTimeZoneInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineTimeZoneInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

  export function TravelineTimeZoneInfoDtoToJSON(json: any): TravelineTimeZoneInfoDto {
      return TravelineTimeZoneInfoDtoToJSONTyped(json, false);
  }

  export function TravelineTimeZoneInfoDtoToJSONTyped(value?: TravelineTimeZoneInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

